/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsSetLimits } from "../../funcs/connectionsSetLimits.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .SetConnectionLimitsConnectionsConnectionIdLimitPutRequest$inboundSchema,
};

export const tool$connectionsSetLimits: ToolDefinition<typeof args> = {
  name: "connections-set-limits",
  description: `Set Connection Limits

Sets limits on a connection. Limits can be set on the total number of pages a connection can sync. When the limit is reached, the connection will be disabled. Limit may be removed by setting it to \`null\`.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsSetLimits(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
